const intelligence = {
  slug: 'f/intelligence',
  purchaseQirBundle: () =>
    `${intelligence.slug}/reports/quarterly/bundle/purchase`,
  purchaseQirSingle: id =>
    `${intelligence.slug}/reports/quarterly/${id}/purchase`,
  getQirList: () => `${intelligence.slug}/reports/quarterly`,
  getQir: slug => `${intelligence.slug}/reports/quarterly/${slug}`,
  getLatestQir: () => `${intelligence.slug}/reports/quarterly/latest`,
  getQirPackages: () => `${intelligence.slug}/reports/quarterly/packages`,
  getAnnualPageLinks: () => `${intelligence.slug}/layout/annual/links`,
  getLayoutSections: () => `${intelligence.slug}/layout/sections`,
  getOurCustomers: () => `${intelligence.slug}/layout/customers`
}

export default intelligence
